import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { useParams } from 'react-router-dom';
import { StoriesDetailWidget } from 'widgets/content/ui/StoriesDetailWidget';

export const StoriesDetailPage = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle(`Сторис #${id}`));
    dispatch(setHeaderAction('edit'));
    dispatch(setActionBtnTitle('Изменить'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <StoriesDetailWidget />;
};
